<template>
  <div style="border-top: 1px solid #e4e7ed">
    <div class="terms">
      <div
        v-if="['HZMB_FIRST_PERSON', 'HZMB_FIRST_COMPANY'].includes(serviceType)"
        v-html="$t('message.terms_body')"
      ></div>
      <div
        v-if="['HZMB_RENEW_PERSON', 'HZMB_RENEW_COMPANY'].includes(serviceType)"
        v-html="$t('message.terms_body2')"
      ></div>
      <div
        v-if="['TAXI_ANNUAL'].includes(serviceType)"
        v-html="$t('message.terms_body3')"
      ></div>
      <div
        v-if="['DRV_LIC_INTER'].includes(serviceType)"
        v-html="$t('message.terms_body4')"
      ></div>
      <div
        v-if="['SCHOOL_RENEW'].includes(serviceType)"
        v-html="$t('school.terms_body_school')"
      ></div>
      <div
        v-if="['HZMB_MO_RENEW_PERSON', 'HZMB_MO_RENEW_COM'].includes(serviceType)"
        v-html="$t('message.terms_body_hzmb_mo')"
      ></div>
      <div
        v-if="['HEADMASTER_RENEW', 'COACH_RENEW'].includes(serviceType)"
        v-html="$t('school.terms_body_staff')"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serviceType: this.$route.params.serviceType,
    };
  },
};
</script>

<style lang="scss" scoped>
.terms {
  max-width: 1200px;
  margin: 0 auto;
  font-size: 16px;
  line-height: 24px;
  padding: 16px;
  background: var(--other-color1);

  /deep/p {
    font-size: 18px;
    font-weight: bold;
  }
  /deep/ul {
    padding-left: 20px;
    list-style-type: decimal;
  }
  /deep/li {
    margin-bottom: 10px;
  }
}
</style>